import useClickOutside from 'app/hooks/useClickOutside';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface MSALError {
  error: string;
  errorDescription: string;
}

export default function useShouldShowSSOErrorDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState<Partial<MSALError>>({});

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.startsWith('error=')) {
      const params = new URLSearchParams(location.pathname);
      const error = params.get('error') ?? '';
      const errorDescription = params.get('error_description') ?? '';

      setIsOpen(true);
      setError({ error, errorDescription });

      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  const close = useCallback(() => {
    setIsOpen(false);
    setError({});
  }, []);

  useClickOutside(close);

  return { isOpen, error, close };
}
